import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "../redux/store";

// ✅ Typed dispatch (səndə bu var idi)
export const useAppDispatch: () => AppDispatch = useDispatch;

// ✅ Bunu əlavə et — typed selector üçün
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
